export enum StepType {
  None = 0,
  OrderCreated = 1,
  UnsvcCreated = 2,
  CoverageControl = 3,
  SendShippingDetail = 4,
  RequestServiceableCreate = 5,
  PoolUserAccept = 6,
  CancellationRepairPeriod = 7,
  ExcusableDelayReminder = 8,
  CapabilityWarrantyPassed = 15,
  PbhServiceableOrderClosed = 16,
  PbhOrderCreated = 17,
  CoreDetailReceived = 18,
  Workshop = 19,
  ReplacementPending = 20,
  CancelRepairProcess = 21,
  ReceivingAlert = 22,
  WsShipmentNotification = 23,
  ServiceableShip = 24,
  AlternatePnOffered = 25,
  AlternatePnReminder = 26,
  WaitingResponseFromCustomer = 27,
  RequestConfirmed = 28,
  RequestRejected = 29,
  ServiceableRejected = 30,
  ServiceableRejectedInformation = 31,
  WaitingPoolScopeReminder = 32,
  NotPlms = 33,
  Quarantine = 34,
  PbhExcusableDelayServiceableReminder = 35,
  PbhServiceableOrderCreate = 36,
  UnshippedSvc = 37,
  PbhUnservicebleOrderCreate = 38,
  PbhServiceableRejected = 39,
  PbhServiceableRejectionProposalRejected = 40,
  PbhAlternatePnResponded = 41,
  PbhAlternatePnOffered = 42,
  PbhRequestRejected = 43,
  PbhServiceableShip = 44,
  WaitingPoolScopeCreate = 45,
  CoreInfoRequestInfoMail = 46,
  PbhExcusableDelayServiceableCreated = 47,
  PbhExcusableDelayUnserviceableCreated = 48,
  PbhCoreLateFeeReminder = 49,
  AircraftUtilizationReminderMail = 50,
  PbhCancelRequestMail = 51,
  CoreInfoRequestRespondedMail = 52,
  ServiceableOfferedAcceptRejectReminder = 53,
  ServiceableOfferedAutoAccepted = 54,
  SendToCmsDashboard = 55,
  PbhExcusableDelayUnserviceableReminder = 56,
  ExcusableDelayServiceableStatusChanged = 57,
  ExcusableDelayUnserviceableStatusChanged = 58,
  PbhWaitingResponseCustomerResponded = 59,
}

export const GetStepType = [
  { Description: "The mail sent when the request is created.", Text: "Order Created", Value: StepType.OrderCreated },
  {
    Description: "The mail sent when the request is created.",
    Text: "Pbh Order Created",
    Value: StepType.PbhOrderCreated,
  },
  {
    Description: "Discarded when unserviceable information is sent.",
    Text: "Core Detail Received",
    Value: StepType.CoreDetailReceived,
  },
  {
    Description: "An e-mail is sent to the workshop about the actions to be taken regarding the component.",
    Text: "Workshop",
    Value: StepType.Workshop,
  },
  {
    Description: "Mail sent when requested to send an Exchange component.",
    Text: "Replacement Pending",
    Value: StepType.ReplacementPending,
  },
  {
    Description: "Rbh process is discarded when a decision is taken to abandon repair and exchange.",
    Text: "Cancel Repair Process",
    Value: StepType.CancelRepairProcess,
  },
  {
    Description: "The e-mail sent when it goes to the delivery stage.",
    Text: "Receiving Alert",
    Value: StepType.ReceivingAlert,
  },
  {
    Description: "Mail sent when serviceable registration is entered.",
    Text: "Ws Shipment Notification",
    Value: StepType.WsShipmentNotification,
  },
  { Description: "The mail sent when the request is created.", Text: "Order Created", Value: StepType.OrderCreated },
  {
    Description: "Discarded as soon as the serviceable component record is created.",
    Text: "Serviceable Ship",
    Value: StepType.ServiceableShip,
  },
  {
    Description: "The status of a record is discarded when alternate pn is offered.",
    Text: "Alternate Pn Offered",
    Value: StepType.AlternatePnOffered,
  },
  {
    Description: "Reminder e-mails are sent 3 times a day for registrations in Alternate pn offered status.",
    Text: "Alternate Pn Reminder",
    Value: StepType.AlternatePnReminder,
  },
  {
    Description: "A record is discarded when its status is waiting from customer.",
    Text: "Waiting Response From Customer",
    Value: StepType.WaitingResponseFromCustomer,
  },
  {
    Description: "The status of a record is discarded as soon as it becomes unshipped svc.",
    Text: "Request Confirmed",
    Value: StepType.RequestConfirmed,
  },
  // { Description: "The record in the Open state is discarded on rejection.", Text: "Request Rejected", Value: StepType.RequestRejected },
  // { Description: "It is discarded as soon as the reject button is pressed in the serviceable tab of a record in the PBH process.", Text: "Serviceable Rejected", Value: StepType.ServiceableRejected },
  {
    Description:
      "In the PBH process, a record in the serviceable rejected list screen is discarded when it is rejected by TT user.",
    Text: "Serviceable Rejected Information",
    Value: StepType.ServiceableRejectedInformation,
  },
  {
    Description:
      "During the PBH process, a reminder e-mail should be sent 3 times a day for the records on the waiting pool scope screen.",
    Text: "Waiting Pool Scope Reminder",
    Value: StepType.WaitingPoolScopeReminder,
  },
  { Description: "Happens after unserviceable create.", Text: "Core Unit Created", Value: StepType.UnsvcCreated },
  { Description: "If there is no coverage.", Text: "Coverage Control", Value: StepType.CoverageControl },
  {
    Description: "For records whose status is capability warranty passed.",
    Text: "Send Shipping Detail",
    Value: StepType.SendShippingDetail,
  },
  {
    Description: "Sent when serviceable occurs.",
    Text: "Request Serviceable Create",
    Value: StepType.RequestServiceableCreate,
  },
  { Description: "If status pool user accept.", Text: "Pool User Accept", Value: StepType.PoolUserAccept },
  {
    Description: "If status cancellation repair period.",
    Text: "Cancellation Repair Period",
    Value: StepType.CancellationRepairPeriod,
  },
  {
    Description: "If excusable records are opened or reopened.",
    Text: "Excusable Delay Reminder",
    Value: StepType.ExcusableDelayReminder,
  },
  {
    Description: "If status capability warranty passed.",
    Text: "Capability Warranty Passed",
    Value: StepType.CapabilityWarrantyPassed,
  },
  {
    Description: "If serviceable order closed.",
    Text: "Pbh Serviceable Order Closed",
    Value: StepType.PbhServiceableOrderClosed,
  },
  {
    Description: "If excusable records are opened or reopened for serviceable shipments.",
    Text: "Pbh Excusable Delay Serviceable Reminder",
    Value: StepType.PbhExcusableDelayServiceableReminder,
  },
  {
    Description: "If excusable records are opened or reopened for unserviceable shipments.",
    Text: "Pbh Excusable Delay Unserviceable Reminder",
    Value: StepType.PbhExcusableDelayUnserviceableReminder,
  },
  {
    Description: "When the status of a serviceable excusable delay record changes.",
    Text: "Excusable Delay Serviceable Status Changed",
    Value: StepType.ExcusableDelayServiceableStatusChanged,
  },
  {
    Description: "When the status of an unserviceable excusable delay record changes.",
    Text: "Excusable Delay Unserviceable Status Changed",
    Value: StepType.ExcusableDelayUnserviceableStatusChanged,
  },
  { Description: "If status not plms.", Text: "Not Plms", Value: StepType.NotPlms },
  { Description: "Quarantine mail.", Text: "Quarantine", Value: StepType.Quarantine },
  {
    Description: "If alternate pn accepted.",
    Text: "Pbh Alternate Pn Responded",
    Value: StepType.PbhAlternatePnResponded,
  },
  {
    Description: "If alternate pn offered.",
    Text: "Pbh Alternate Pn Responded",
    Value: StepType.PbhAlternatePnOffered,
  },
  {
    Description: "If status Waiting Pool Scope.",
    Text: "Waiting Pool Scope Reminder",
    Value: StepType.WaitingPoolScopeReminder,
  },
  {
    Description: "If status Waiting Response From Customer.",
    Text: "Waiting Response From Customer",
    Value: StepType.WaitingResponseFromCustomer,
  },
  { Description: "If serviceable rejected.", Text: "Pbh Serviceable Rejected", Value: StepType.PbhServiceableRejected },
  { Description: "If status Unshipped Serviceable.", Text: "Unshipped Serviceable", Value: StepType.UnshippedSvc },
  { Description: "If order rejected.", Text: "Request Rejected", Value: StepType.PbhRequestRejected },
  {
    Description: "When moving from Rejection Proposal status to Serviceable Shipped status.",
    Text: "Pbh Serviceable Rejection Proposal Rejected",
    Value: StepType.PbhServiceableRejectionProposalRejected,
  },
  {
    Description:
      "When an unserviceable record is entered by the customer during the PBH process, an automatic e-mail should be sent.",
    Text: "Pbh Unserviceable Order Create",
    Value: StepType.PbhUnservicebleOrderCreate,
  },
  {
    Description:
      "When an serviceable record is entered by the customer during the PBH process, an automatic e-mail should be sent.",
    Text: "Pbh Serviceable Order Create",
    Value: StepType.PbhServiceableOrderCreate,
  },
  {
    Description:
      "When a serviceable record is entered by the customer in the PBH process, the e-mail sent in case of approval or rejection.",
    Text: "Pbh Serviceable Ship",
    Value: StepType.PbhServiceableShip,
  },
  {
    Description: "If a PBH request record is created in the Waiting Pool Scope status.",
    Text: "Pbh Create Waiting Pool Scope",
    Value: StepType.WaitingPoolScopeCreate,
  },
  {
    Description: "When a Core Info Request Added & Edited & Rejected by the TT User ",
    Text: "Core Info Status Info Mail",
    Value: StepType.CoreInfoRequestInfoMail,
  },
  {
    Description: "When an excusable delay created for PBH Serviceable  ",
    Text: "PBH Request Excusable Serviceable",
    Value: StepType.PbhExcusableDelayServiceableCreated,
  },
  {
    Description: "When an excusable delay created for PBH Unserviceable  ",
    Text: "PBH Request Excusable Core Unit",
    Value: StepType.PbhExcusableDelayUnserviceableCreated,
  },
  {
    Description: "Customer to be reminded to send core component  ",
    Text: "PBH Core Late Fee Reminder",
    Value: StepType.PbhCoreLateFeeReminder,
  },
  {
    Description: "Customer to be reminded to send aircraft utilization for their aircrafts  ",
    Text: "PBH Aircraft Utilization Reminder",
    Value: StepType.AircraftUtilizationReminderMail,
  },
  {
    Description: "Inform Customer when the order is cancelled ",
    Text: "PBH Request Order Cancel Mail",
    Value: StepType.PbhCancelRequestMail,
  },
  {
    Description: "When a PBH request order is sent to CMS Dashboard",
    Text: "PBH Send To CMS Dashboard",
    Value: StepType.SendToCmsDashboard,
  },
  {
    Description: "PBH Serviceable Reminder",
    Text: "PBH Serviceable Reminder",
    Value: StepType.ServiceableOfferedAutoAccepted,
  },
  {
    Description: "PBH Serviceable Reject Reminder",
    Text: "PBH Serviceable Reject Reminder",
    Value: StepType.ServiceableOfferedAcceptRejectReminder,
  },
];

export const GetRbhStepType = [
  { Description: "The mail sent when the request is created.", Text: "Order Created", Value: StepType.OrderCreated },
  {
    Description: "Discarded when unserviceable information is sent.",
    Text: "Core Detail Received",
    Value: StepType.CoreDetailReceived,
  },
  {
    Description: "An e-mail is sent to the workshop about the actions to be taken regarding the component.",
    Text: "Workshop",
    Value: StepType.Workshop,
  },
  {
    Description: "Mail sent when requested to send an Exchange component.",
    Text: "Replacement Pending",
    Value: StepType.ReplacementPending,
  },
  {
    Description: "Rbh process is discarded when a decision is taken to abandon repair and exchange.",
    Text: "Cancel Repair Process",
    Value: StepType.CancelRepairProcess,
  },
  {
    Description: "The e-mail sent when it goes to the delivery stage.",
    Text: "Receiving Alert",
    Value: StepType.ReceivingAlert,
  },
  {
    Description: "Mail sent when serviceable registration is entered.",
    Text: "Ws Shipment Notification",
    Value: StepType.WsShipmentNotification,
  },
  { Description: "Happens after unserviceable create.", Text: "Core Unit Created", Value: StepType.UnsvcCreated },
  { Description: "If there is no coverage.", Text: "Coverage Control", Value: StepType.CoverageControl },
  {
    Description: "For records whose status is capability warranty passed.",
    Text: "Send Shipping Detail",
    Value: StepType.SendShippingDetail,
  },
  {
    Description: "Sent when serviceable occurs.",
    Text: "Request Serviceable Create",
    Value: StepType.RequestServiceableCreate,
  },
  { Description: "If status pool user accept.", Text: "Pool User Accept", Value: StepType.PoolUserAccept },
  {
    Description: "If status cancellation repair period.",
    Text: "Cancellation Repair Period",
    Value: StepType.CancellationRepairPeriod,
  },
  {
    Description: "If status capability warranty passed.",
    Text: "Capability Warranty Passed",
    Value: StepType.CapabilityWarrantyPassed,
  },
  { Description: "If status not plms.", Text: "Not Plms", Value: StepType.NotPlms },
  { Description: "Quarantine mail.", Text: "Quarantine", Value: StepType.Quarantine },
  {
    Description: "If excusable records are opened or reopened.",
    Text: "Excusable Delay Reminder",
    Value: StepType.ExcusableDelayReminder,
  },
];

export const GetPbhStepType = [
  {
    Description: "The mail sent when the request is created.",
    Text: "Pbh Order Created",
    Value: StepType.PbhOrderCreated,
  },
  {
    Description: "Discarded as soon as the serviceable component record is created.",
    Text: "Serviceable Ship",
    Value: StepType.ServiceableShip,
  },
  // { Description: "The status of a record is discarded when alternate pn is offered.", Text: "Alternate Pn Offered", Value: StepType.AlternatePnOffered },
  {
    Description: "Reminder e-mails are sent 3 times a day for registrations in Alternate pn offered status.",
    Text: "Alternate Pn Reminder",
    Value: StepType.AlternatePnReminder,
  },
  {
    Description: "A record is discarded when its status is waiting from customer.",
    Text: "Waiting Response From Customer",
    Value: StepType.WaitingResponseFromCustomer,
  },
  {
    Description: "The status of a record is discarded as soon as it becomes unshipped svc.",
    Text: "Request Confirmed",
    Value: StepType.RequestConfirmed,
  },
  {
    Description: "The record in the Open state is discarded on rejection.",
    Text: "Request Rejected",
    Value: StepType.RequestRejected,
  },
  {
    Description:
      "It is discarded as soon as the reject button is pressed in the serviceable tab of a record in the PBH process.",
    Text: "Serviceable Rejected",
    Value: StepType.ServiceableRejected,
  },
  {
    Description:
      "In the PBH process, a record in the serviceable rejected list screen is discarded when it is rejected by TT user.",
    Text: "Serviceable Rejected Information",
    Value: StepType.ServiceableRejectedInformation,
  },
  {
    Description:
      "During the PBH process, a reminder e-mail should be sent 3 times a day for the records on the waiting pool scope screen.",
    Text: "Waiting Pool Scope Reminder",
    Value: StepType.WaitingPoolScopeReminder,
  },
  {
    Description: "If serviceable order closed.",
    Text: "Pbh Serviceable Order Closed",
    Value: StepType.PbhServiceableOrderClosed,
  },
  {
    Description: "If excusable records are opened or reopened for serviceable shipments.",
    Text: "Pbh Excusable Delay Serviceable Reminder",
    Value: StepType.PbhExcusableDelayServiceableReminder,
  },
  {
    Description: "If excusable records are opened or reopened for unserviceable shipments.",
    Text: "Pbh Excusable Delay Unserviceable Reminder",
    Value: StepType.PbhExcusableDelayUnserviceableReminder,
  },
  {
    Description: "When the status of a serviceable excusable delay record changes.",
    Text: "Excusable Delay Serviceable Status Changed",
    Value: StepType.ExcusableDelayServiceableStatusChanged,
  },
  {
    Description: "When the status of an unserviceable excusable delay record changes.",
    Text: "Excusable Delay Unserviceable Status Changed",
    Value: StepType.ExcusableDelayUnserviceableStatusChanged,
  },
  {
    Description: "If alternate pn accepted.",
    Text: "Pbh Alternate Pn Responded",
    Value: StepType.PbhAlternatePnResponded,
  },
  { Description: "If alternate pn offered.", Text: "Alternate Pn Offered", Value: StepType.PbhAlternatePnOffered },
  {
    Description: "If status Waiting Pool Scope.",
    Text: "Waiting Pool Scope Reminder",
    Value: StepType.WaitingPoolScopeReminder,
  },
  {
    Description: "If status Waiting Response From Customer.",
    Text: "Waiting Response From Customer",
    Value: StepType.WaitingResponseFromCustomer,
  },
  { Description: "If serviceable rejected.", Text: "Pbh Serviceable Rejected", Value: StepType.PbhServiceableRejected },
  { Description: "If status Unshipped Serviceable.", Text: "Unshipped Serviceable", Value: StepType.UnshippedSvc },
  { Description: "If order rejected.", Text: "Request Rejected", Value: StepType.PbhRequestRejected },
  {
    Description: "When moving from Rejection Proposal status to Serviceable Shipped status.",
    Text: "Pbh Serviceable Rejection Proposal Rejected",
    Value: StepType.PbhServiceableRejectionProposalRejected,
  },
  {
    Description:
      "When an unserviceable record is entered by the customer during the PBH process, an automatic e-mail should be sent.",
    Text: "Pbh Unserviceable Order Create",
    Value: StepType.PbhUnservicebleOrderCreate,
  },
  {
    Description:
      "When an serviceable record is entered by the customer during the PBH process, an automatic e-mail should be sent.",
    Text: "Pbh Serviceable Order Create",
    Value: StepType.PbhServiceableOrderCreate,
  },
  {
    Description:
      "When a serviceable record is entered by the customer in the PBH process, the e-mail sent in case of approval or rejection.",
    Text: "Pbh Serviceable Ship",
    Value: StepType.PbhServiceableShip,
  },
  {
    Description: "If a PBH request record is created in the Waiting Pool Scope status.",
    Text: "Pbh Create Waiting Pool Scope",
    Value: StepType.WaitingPoolScopeCreate,
  },
  {
    Description: "When a Core Info Request Added & Edited & Rejected by the TT User ",
    Text: "Core Info Status Info Mail",
    Value: StepType.CoreInfoRequestInfoMail,
  },
  {
    Description: "When an excusable delay created for PBH Serviceable  ",
    Text: "PBH Request Excusable Serviceable",
    Value: StepType.PbhExcusableDelayServiceableCreated,
  },
  {
    Description: "When an excusable delay created for PBH Unserviceable  ",
    Text: "PBH Request Excusable Core Unit",
    Value: StepType.PbhExcusableDelayUnserviceableCreated,
  },
  {
    Description: "Customer to be reminded to send core component",
    Text: "PBH Core Late Fee Reminder",
    Value: StepType.PbhCoreLateFeeReminder,
  },
  {
    Description: "Customer to be reminded to send aircraft utilization for their aircrafts  ",
    Text: "PBH Aircraft Utilization Reminder",
    Value: StepType.AircraftUtilizationReminderMail,
  },
  {
    Description: "Inform Customer when the order is cancelled ",
    Text: "PBH Request Order Cancel Mail",
    Value: StepType.PbhCancelRequestMail,
  },
  {
    Description: "Inform Turkish Technic  when the core info request responded ",
    Text: "PBH Core Info Responded Mail",
    Value: StepType.CoreInfoRequestRespondedMail,
  },
  {
    Description: "When a PBH request order is sent to CMS Dashboard",
    Text: "PBH Send To CMS Dashboard",
    Value: StepType.SendToCmsDashboard,
  },
  {
    Description: "PBH Serviceable Reminder",
    Text: "PBH Serviceable Reminder",
    Value: StepType.ServiceableOfferedAutoAccepted,
  },
  {
    Description: "PBH Serviceable Reject Reminder",
    Text: "PBH Serviceable Reject Reminder",
    Value: StepType.ServiceableOfferedAcceptRejectReminder,
  },
  {
    Description: "PBH Response From Customer",
    Text: "PBH Response From Customer",
    Value: StepType.PbhWaitingResponseCustomerResponded,
  },
];
